module.exports = __webpack_public_path__ + "img/russia.7a8b3a7d.svg";